<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex>
        <file-drop v-on:files-selected="doSomething"></file-drop>

        <!--
        <v-sheet
          id="fileZone"
          ref="dzone"
          tabindex="0"
          title="Click to upload"
          color="blue lighten-4"
          width="100%"
          height="200"
          class="pa-2"
          @drop.prevent="addDropFile" @dragover.prevent
        >
        </v-sheet>
        -->

        <v-text-field
          label="Select..."
          @click="selectFile"
          v-model="file.name"
          prepend-icon="attach_file"
        ></v-text-field>
        <input
          accept="*/*"
          @change="fileSelected"
          ref="fileInput"
          style="display: none"
          type="file"
        />

        <v-btn
          color="primary"
          @click.stop="convert"
          :loading="loading"
        >convert</v-btn>

        <hr />

        <v-textarea
          v-model="rows"
          label="Rows"
          auto-grow
          box
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ReadXlsxFile from 'read-excel-file'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import StoreMixin from '@/store/mixin'

import FileDrop from '@/components/forms/FileDrop'

export default {
  mixins: [ApiMixin, AuthMixin, StoreMixin],

  components: {FileDrop},

  data: function () {
    return {
      loading: false,
      file: {
        data: null,
        name: '',
        url: ''
      },
      rows: []
    }
  },

  methods: {
    selectFile () {
      this.$refs.fileInput.click()
    },

    doSomething () {
      console.log('doSomething')
    },

    fileSelected (event) {
      console.log('ConvertExcel.fileSelected')
      this.loading = true

      const files = event.target.files
      if (files[0] !== undefined) {
        this.file.name = files[0].name

        if (this.file.name.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file.url = fr.result
          this.file.data = files[0]
        })
      } else {
        this.file.name = ''
        this.file.data = null
        this.file.url = ''
      }

      this.loading = false
    },

    convert: function () {
      this.loading = true

      ReadXlsxFile(this.file).then((rows) => {
        this.rows = rows
      })

      this.loading = false
    }
  }
}
</script>

<style>
#decoded {
  height: 100%;
  resize: both;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/utilities/ConvertExcel.vue